import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ServerConnectionService} from "../../services/serverConnection/server-connection.service";
import {observable, Observable} from "rxjs";
declare var Yiit;
@Component({
  selector: 'app-server-connection-status',
  templateUrl: './server-connection-status.component.html',
  styleUrls: ['./server-connection-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServerConnectionStatusComponent implements OnInit {

  public status = 'disconnected';
  public requestCount = 0;
  public lastUpdated = new Date().toLocaleTimeString();
  public Yiit = Yiit;

  constructor(protected serverConnection: ServerConnectionService, protected cd:ChangeDetectorRef) {
    this.initializeListeners();
  }

  ngOnInit() {
  }

  initializeListeners() {
    this.serverConnection.onBeforeRequest(() => {
      this.requestCount++;
      this.cd.detectChanges();
    });
    this.serverConnection.onAfterRequest(() => {
      this.requestCount--;
      this.lastUpdated = new Date().toLocaleTimeString();
      this.cd.detectChanges();
    });
    this.serverConnection.on('connect', () => { this.status = 'connected'; this.cd.detectChanges();});
    this.serverConnection.on('reconnect', () => { this.status = 'connected'; this.cd.detectChanges();});
    this.serverConnection.on('disconnect', () => { this.status = 'disconnected'; this.cd.detectChanges();});
    this.serverConnection.on('NETWORK_LOST', () => { this.status = 'disconnected'; this.cd.detectChanges();});
    this.serverConnection.on('NETWORK_RESTORED', () => { if (this.serverConnection.isConnected()){this.status = 'connected'; }});
  }

  isConnected() {
    return this.status == 'connected';
  }

}
